import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { C, PageHeader, GlassCard, Badge, Skeleton, Input, Toggle } from "@coremonit/design-system";
import { ListTree, Search, AlertTriangle } from "lucide-react";
import { useTraces } from "../api/hooks";

export function TracingPage() {
  const [q, setQ] = useState("");
  const [onlyErrors, setOnlyErrors] = useState(false);
  const nav = useNavigate();
  const traces = useTraces({ q: q || undefined, onlyErrors });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <PageHeader icon={<ListTree size={16} />} title="Distributed Tracing" subtitle="Waterfall · critical path · parent–child · AI trace summaries." />

      <GlassCard style={{ padding: 12 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 220 }}><Input value={q} onChange={setQ} prefix={<Search size={13} />} placeholder="Search operation…" /></div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, color: C.textSub, fontSize: 11 }}>
            <span>Errors only</span>
            <Toggle value={onlyErrors} onChange={setOnlyErrors} />
          </div>
        </div>
      </GlassCard>

      <GlassCard style={{ padding: 0, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, fontSize: 12 }}>
            <thead>
              <tr style={{ background: C.surfaceHigh, color: C.textMuted, fontSize: 10, textTransform: "uppercase", letterSpacing: 0.4 }}>
                <th style={{ padding: "10px 14px", textAlign: "left" }}>Root operation</th>
                <th style={{ padding: "10px 14px", textAlign: "left" }}>Service</th>
                <th style={{ padding: "10px 14px", textAlign: "right" }}>Duration</th>
                <th style={{ padding: "10px 14px", textAlign: "right" }}>Spans</th>
                <th style={{ padding: "10px 14px", textAlign: "right" }}>Services</th>
                <th style={{ padding: "10px 14px" }}>Status</th>
                <th style={{ padding: "10px 14px" }}>When</th>
              </tr>
            </thead>
            <tbody>
              {traces.isLoading
                ? Array.from({ length: 6 }, (_, i) => <tr key={i}><td colSpan={7} style={{ padding: 14 }}><Skeleton height={20} /></td></tr>)
                : traces.data?.items.map((t) => (
                    <tr key={t.id} onClick={() => nav(`/traces/${t.id}`)} style={{ cursor: "pointer", borderTop: `1px solid ${C.border}` }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = C.surfaceHigh)}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}>
                      <td style={{ padding: "10px 14px", color: C.text }}>{t.rootOperation}</td>
                      <td style={{ padding: "10px 14px", color: C.textSub }}>{t.rootService}</td>
                      <td style={{ padding: "10px 14px", textAlign: "right", color: t.durationMs > 800 ? C.amber : C.text, fontVariantNumeric: "tabular-nums" }}>{t.durationMs}ms</td>
                      <td style={{ padding: "10px 14px", textAlign: "right", color: C.textSub, fontVariantNumeric: "tabular-nums" }}>{t.spanCount}</td>
                      <td style={{ padding: "10px 14px", textAlign: "right", color: C.textSub, fontVariantNumeric: "tabular-nums" }}>{t.services.length}</td>
                      <td style={{ padding: "10px 14px" }}>{t.hasError ? <Badge color="red"><AlertTriangle size={9} /> {t.errorCount}</Badge> : <Badge color="green">ok</Badge>}</td>
                      <td style={{ padding: "10px 14px", color: C.textMuted, fontSize: 10 }}>{new Date(t.startedAt).toLocaleTimeString()}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </GlassCard>
    </div>
  );
}
